import { Component } from '@angular/core';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';

/* Not done. Assumed to be a form where users can manually upload a rate.*/
@Component({
  selector: 'app-create-rates',
  templateUrl: './create-rates.component.html',
  styleUrls: ['./create-rates.component.scss']
})
export class CreateRatesComponent {
  rates_form: FormGroup = this.fb.group({
    rate_type: ['', Validators.required],
    //TO DO: set below to required if relevant rate type selected
    linear_range: [''],
    origin_zone: [''],
    destination_zone: [''],
    cubic_range: [''],
    start_date: [new Date(), Validators.required],
    end_date: [new Date, Validators.required],
    LTL_FTL: [''],
    customer_name: ['']
  })

  rate_type_options = {
    'linear_feet': 'Linear Feet',
    'cubic_weight': 'Cubic Weight (lbs)',
    'zone': 'Zones'
  };

  cubic_range_options = ['0 - 499', '500 - 999', '1000 - 1499', '1500 - 1999', '10,000 - 19,999', '20,000+'];

  constructor(private fb: FormBuilder){}
}

// ranges: 0-499, 500-999, 1000-1999, 10,000-19,999, 20,000+
export const cubic_lbs_ranges = [499, 999, 1499, 1999, 19999];
